// All envs are reexported here to mock them in tests
declare global {
  interface Window {
    __APP_CONFIG__?: {
      NGINX_API_PROXY_IP?: string;
      NGINX_API_PROXY_HOST?: string;
      API_URL?: string;
      APP_VERSION?: string;
      UNLEASH_URL?: string;
      UNLEASH_CLIENT_KEY?: string;
      UNLEASH_POLL_INTERVAL_SEC?: string;
      PARTNER_ID?: string;
      SENTRY_DSN?: string;
      SENTRY_ENV_NAME?: string;
      USER_AGREEMENT_URL?: string;
      CONSENT_PERSONAL_DATA_URL?: string;
      CONSENT_CREDIT_HISTORY_URL?: string;
      CONSENT_MAILING_LIST_URL?: string;
      CONSENT_LIMIT_OFFER_URL?: string;
      SUPPORT_PHONE_NUMBER?: string;
      SUPPORT_EMAIL_ADDRESS?: string;
      YANDEX_METRICA_ID?: string;
      LOCAL_BACKEND_URL?: string;
    };
  }
}

const runtimeConfig = typeof window !== "undefined" ? window.__APP_CONFIG__ : undefined;
const buildTimeEnv = import.meta.env;

const DEV = buildTimeEnv.DEV; // is local development
const MODE = buildTimeEnv.MODE as "develop" | "test" | "preprod" | "main"; // stands
const PROD = buildTimeEnv.PROD; // is any stand (develop, test, preprod, main)

const VITE_NGINX_API_PROXY_IP = (runtimeConfig?.NGINX_API_PROXY_IP ?? buildTimeEnv.VITE_NGINX_API_PROXY_IP);
const VITE_NGINX_API_PROXY_HOST = (runtimeConfig?.NGINX_API_PROXY_HOST ?? buildTimeEnv.VITE_NGINX_API_PROXY_HOST);
const VITE_API_URL = (runtimeConfig?.API_URL ?? buildTimeEnv.VITE_API_URL);
const VITE_APP_VERSION = runtimeConfig?.APP_VERSION ?? buildTimeEnv.VITE_APP_VERSION;
const VITE_UNLEASH_URL = runtimeConfig?.UNLEASH_URL ?? buildTimeEnv.VITE_UNLEASH_URL;
const VITE_UNLEASH_CLIENT_KEY = runtimeConfig?.UNLEASH_CLIENT_KEY ?? buildTimeEnv.VITE_UNLEASH_CLIENT_KEY;
const VITE_UNLEASH_POLL_INTERVAL_SEC = runtimeConfig?.UNLEASH_POLL_INTERVAL_SEC ?? buildTimeEnv.VITE_UNLEASH_POLL_INTERVAL_SEC;
const VITE_PARTNER_ID = (runtimeConfig?.PARTNER_ID ?? buildTimeEnv.VITE_PARTNER_ID);
const VITE_SENTRY_DSN = (runtimeConfig?.SENTRY_DSN ?? buildTimeEnv.VITE_SENTRY_DSN);
const VITE_SENTRY_ENV_NAME = (runtimeConfig?.SENTRY_ENV_NAME ?? buildTimeEnv.VITE_SENTRY_ENV_NAME);
const VITE_USER_AGREEMENT_URL = (runtimeConfig?.USER_AGREEMENT_URL ?? buildTimeEnv.VITE_USER_AGREEMENT_URL);
const VITE_CONSENT_PERSONAL_DATA_URL = (runtimeConfig?.CONSENT_PERSONAL_DATA_URL ?? buildTimeEnv.VITE_CONSENT_PERSONAL_DATA_URL);
const VITE_CONSENT_CREDIT_HISTORY_URL = (runtimeConfig?.CONSENT_CREDIT_HISTORY_URL ?? buildTimeEnv.VITE_CONSENT_CREDIT_HISTORY_URL);
const VITE_CONSENT_MAILING_LIST_URL = (runtimeConfig?.CONSENT_MAILING_LIST_URL ?? buildTimeEnv.VITE_CONSENT_MAILING_LIST_URL);
const VITE_CONSENT_LIMIT_OFFER_URL = (runtimeConfig?.CONSENT_LIMIT_OFFER_URL ?? buildTimeEnv.VITE_CONSENT_LIMIT_OFFER_URL);
const VITE_SUPPORT_PHONE_NUMBER = (runtimeConfig?.SUPPORT_PHONE_NUMBER ?? buildTimeEnv.VITE_SUPPORT_PHONE_NUMBER);
const VITE_SUPPORT_EMAIL_ADDRESS = (runtimeConfig?.SUPPORT_EMAIL_ADDRESS ?? buildTimeEnv.VITE_SUPPORT_EMAIL_ADDRESS);
const VITE_YANDEX_METRICA_ID = (runtimeConfig?.YANDEX_METRICA_ID ?? buildTimeEnv.VITE_YANDEX_METRICA_ID);
const VITE_LOCAL_BACKEND_URL = (runtimeConfig?.LOCAL_BACKEND_URL ?? buildTimeEnv.VITE_LOCAL_BACKEND_URL);

if (typeof window !== "undefined" && (DEV || MODE === "develop" || MODE === "test" || MODE === "preprod")) {
  console.log("[ENV]:", {
    DEV,
    MODE,
    PROD,
    VITE_NGINX_API_PROXY_IP,
    VITE_NGINX_API_PROXY_HOST,
    VITE_API_URL,
    VITE_APP_VERSION,
    VITE_UNLEASH_URL,
    VITE_UNLEASH_CLIENT_KEY,
    VITE_UNLEASH_POLL_INTERVAL_SEC,
    VITE_PARTNER_ID,
    VITE_SENTRY_DSN,
    VITE_SENTRY_ENV_NAME,
    VITE_USER_AGREEMENT_URL,
    VITE_CONSENT_PERSONAL_DATA_URL,
    VITE_CONSENT_CREDIT_HISTORY_URL,
    VITE_CONSENT_MAILING_LIST_URL,
    VITE_CONSENT_LIMIT_OFFER_URL,
    VITE_SUPPORT_PHONE_NUMBER,
    VITE_SUPPORT_EMAIL_ADDRESS,
    VITE_YANDEX_METRICA_ID,
    VITE_LOCAL_BACKEND_URL,
  });
}

export {
  DEV,
  MODE,
  PROD,
  VITE_NGINX_API_PROXY_IP,
  VITE_NGINX_API_PROXY_HOST,
  VITE_API_URL,
  VITE_APP_VERSION,
  VITE_UNLEASH_URL,
  VITE_UNLEASH_CLIENT_KEY,
  VITE_UNLEASH_POLL_INTERVAL_SEC,
  VITE_PARTNER_ID,
  VITE_SENTRY_DSN,
  VITE_SENTRY_ENV_NAME,
  VITE_USER_AGREEMENT_URL,
  VITE_CONSENT_PERSONAL_DATA_URL,
  VITE_CONSENT_CREDIT_HISTORY_URL,
  VITE_CONSENT_MAILING_LIST_URL,
  VITE_CONSENT_LIMIT_OFFER_URL,
  VITE_SUPPORT_PHONE_NUMBER,
  VITE_SUPPORT_EMAIL_ADDRESS,
  VITE_YANDEX_METRICA_ID,
  VITE_LOCAL_BACKEND_URL,
};
